import { array, number, string, bool, object } from "prop-types";
import useMatchMedia from "../../common/useMatchMedia.js";
import cx from "classnames";

import StyledLink from "../StyledLink/StyledLink.jsx";

const propTypes = {
  image: object,
  url: string,
  title: string,
  view: string,
};

const truncateText = (text) => {
  const matchesLarge = useMatchMedia("(min-width: 1024px)");
  const matchesMedium = useMatchMedia("(min-width: 746px)");
  const matchesExtraSmall = useMatchMedia("(min-width: 470px)");
  let charCount;

  if (matchesLarge) {
    charCount = 300;
  } else if (matchesMedium) {
    charCount = 1200;
  } else if (matchesExtraSmall) {
    charCount = 700;
  } else {
    charCount = 300;
  }

  return text.substring(0, charCount) + "...";
};

const ContentCard = (props) => {
  const { image, url, title, view } = props;

  const matchesLarge = useMatchMedia("(min-width: 1024px)");

  const keyDown = (e) => {
    if (e.key === "Enter") {
      window.location.assign(url);
    }
  }

  return (
    <div
      className={cx("content-card", {
        "content-card--grid": view === "grid",
        "content-card--single": view === "list" && matchesLarge,
      })}
      onClick={() => url && window.location.assign(url)}
      onKeyDown={keyDown}
      role="link"
      tabIndex="0"
    >
      {image && (
        <div className="content-card__img">
          <img
            srcSet={`
                ${image.grid1x} 342w,
                ${image.grid2x} 684w,
            `}
            sizes="
                (min-width: 470px) 100%
            "
            src={image.grid1x}
            alt={image.alt ? image.alt : ""}
            loading="lazy"
          />
        </div>
      )}
      <div className="content-card__content">
        {url && (
          <a
            className="styled-link content-card__link"
            href={url}
            tabIndex="-1"
          >
            {title}
            <span>
              <>&#65279;</>
              {rightArrowIcon}
            </span>
          </a>
        )}
      </div>
    </div>
  );
};

ContentCard.propTypes = propTypes;
export default ContentCard;

const rightArrowIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-arrow-right"
  >
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);
